import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {EmailThreadLabel, Recipient, SingleEmail} from '@features/inbox/interfaces/email-thread-label';

@Component({
    standalone: false,
    selector: 'app-single-email-container',
  templateUrl: './single-email-container.component.html',
  styleUrls: ['./single-email-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SingleEmailContainerComponent implements OnInit {
  @Input() email: SingleEmail;
  @Input() labels: EmailThreadLabel[];
  @Output() emailAction = new EventEmitter<any>();
  now: Date = new Date();
  recipientsDisplayText = '';
  showEditor: boolean;
  newEmailRecipients: Recipient;
  constructor() {

  }

  ngOnInit(): void {
    setInterval(() => {
      this.now = new Date();
    }, 5000);
    this.recipientsDisplayText = [this.email.recipients.to, ...this.email.recipients.cc]
      .map(o => `${o.firstName} ${o.lastName}`).join(', ');
  }

  onSenderEmailClick(email: string) {

  }

  onEmailAction(actionType: string, data?: any) {
    switch (actionType) {
      case 'reply':
        this.showEditor = true;
        this.newEmailRecipients = {to: this.email.sender, cc: []} as Recipient;
        return;
      case 'forward':
        this.showEditor = true;
        this.newEmailRecipients = {} as Recipient;
        return;
      case 'replyAll':
        this.showEditor = true;
        this.newEmailRecipients = this.email.recipients;
        return;
      case 'send':
        this.showEditor = false;
        return;
      case 'discard':
        this.discardMail();
        return;
    }
    console.log({action: { id: actionType}, data: data});
    this.emailAction.emit({action: { id: actionType}, data: data});
  }

  discardMail() {
    this.showEditor = !this.showEditor;
  }
}
